module.exports = __webpack_public_path__ + "img/CA-1.96bca5e4.jpg";